import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { getSupportSiteBaseUrl } from '@/shared/lib/support-site';
import { openExternalUrl } from '@/shared/lib/utils/url';
import { Button, Tooltip } from '@/shared/ui';

const SUPPORT_MANUAL_URL = getSupportSiteBaseUrl();

/**
 * サポートマニュアルボタン（グローバルナビゲーション右上）
 * クリックすると新しいタブでサポートマニュアルを開く
 */
export const SupportManualButton = () => {
  const { t } = useTranslation();

  return (
    <Tooltip tooltipContent={t('common.actions.help-center')}>
      <Button
        variant="outline"
        size="icon"
        aria-label={t('common.actions.help-center')}
        onClick={() => openExternalUrl(SUPPORT_MANUAL_URL)}
      >
        <QuestionMarkCircleIcon className="text-text-muted" />
      </Button>
    </Tooltip>
  );
};
